import {$http, Constants} from '@/store/actions/constants';

export const AuthActions = {
    activate: ({ }, payload) => {
        return $http.post(`${Constants.BaseURL}/auth/`, payload);
    },

    status: ({commit, state}) => {
        return $http.get(`${Constants.BaseURL}/auth/status`, state.authHeader);
    },

    generatePasswordEmail: ({state}, email) => {
        let payload = {email: email}
        return $http.post(`${Constants.BaseURL}/auth/reset-password`, payload)
    },
    userByActivationCode: ({state}, data) => {
        return $http.get(`${Constants.BaseURL}/auth/get-user?namespace=${data.namespace}&activation_code=${data.activation_code}`)
    },
    // to explicitly call the activation endpoint after the user
    // has changed the password after being invited
    activateEmpAccount: ({state}, payload) => {
        let email = encodeURIComponent(payload.email)
        let uu = encodeURI(`${Constants.BaseURL}/auth/activate?email=${email}&companyID=${payload.companyID}&namespace=${payload.namespace}`)
        return $http.get(uu)
    },
    accessRequestList: ({commit, state}, search) => {
        let url = `${Constants.BaseURL}/auth/access-request`
        return $http.get(url, {...state.authHeader, params: search}).then(r => {
            if (r.status === 200) {
                commit('SET_ACCESS_REQUESTS', r.data);
            }
        });
    },
    addAccessRequest: ({state}, payload) => {
        let url = `${Constants.BaseURL}/auth/access-request`
        return $http.post(url, payload, state.authHeader)
    }

};